import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { MarkAllReadLegacyButton } from "web_myplann/NotificationCenter/Components/MarkAllReadLegacyButton";
import { MarkAllReadV2Button } from "web_myplann/NotificationCenter/Components/MarkAllReadV2Button";
import type { MarkAllReadButtonProps } from "web_myplann/NotificationCenter/Types/MarkAllReadButtonProps";

export const MarkAllReadButton: FC<MarkAllReadButtonProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();
	return hasGoalsRight ? (
		<MarkAllReadV2Button {...props} />
	) : (
		<MarkAllReadLegacyButton {...props} />
	);
};
